import { useState } from "react";
import AccordianComp from "../AccordianComp";
import classes from "./Faqs.module.css";

const DEFAULT_FAQS = [];

export default function Faqs({
  faqs = DEFAULT_FAQS,
  title = "Frequently Asked Questions",
  description = "Have questions about MITSI and our services? Check out our FAQ section to find answers to common queries.",
}) {
  const [openId, setOpenId] = useState(faqs[0]?.id ?? 1);

  if (!Array.isArray(faqs) || !faqs.length) {
    return null;
  }

  const handleToggle = (id) => {
    setOpenId((currentId) => (currentId === id ? null : id));
  };

  const leftFaqs = [];
  const rightFaqs = [];

  faqs.forEach((faq, index) => {
    const item = {
      ...faq,
      displayNumber: index + 1,
    };

    if (index % 2 === 0) {
      leftFaqs.push(item);
    } else {
      rightFaqs.push(item);
    }
  });

  const renderFaqs = (items) =>
    items.map((faq) => {
      const faqId = faq.id ?? faq.displayNumber;

      return (
        <AccordianComp
          key={faqId}
          question={faq.question}
          answer={faq.answer}
          isOpen={openId === faqId}
          onToggle={() => handleToggle(faqId)}
          number={faq.displayNumber}
        />
      );
    });

  return (
    <section className={classes.section} aria-labelledby="faq-title">
      <div className={classes.container}>
        <header className={classes.header}>
          <h2 id="faq-title" className={classes.title}>
            {title}
          </h2>

          <p className={classes.description}>
            {description}
          </p>
        </header>

        <div className={classes.faqColumns}>
          <div className={classes.faqColumn}>
            {renderFaqs(leftFaqs)}
          </div>

          <div className={classes.faqColumn}>
            {renderFaqs(rightFaqs)}
          </div>
        </div>
      </div>
    </section>
  );
}
